// src/pages/user/UserNotificationsPage.jsx

import React, { useState, useContext, useEffect } from 'react';
import { Container, Row, Col, Card, Badge, Button, ButtonGroup } from 'react-bootstrap';
import {
  FaBell, FaCheckCircle, FaClock, FaTrash, FaEnvelopeOpen,
  FaShoppingCart, FaTools, FaExclamationTriangle, FaStar,
  FaMoneyBillWave, FaTimesCircle, FaTractor
} from 'react-icons/fa';
import axios from 'axios';
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext.js";
import UserMasterLayout from '../../../layout/useradmin/UserMasterLayout.js';
import '../../../assets/css/useradmin/notifications/Notifications.css';
import { getEcho } from "../../../utils/echo";

const UserNotificationsPage = () => {
  const { baseUrl, loggedInCustomer } = useContext(AppContext);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);

  // ── PUSHER — is customer ke liye naya notification aate hi list
  //    ke upar add ho jayega, real-time ──
  useEffect(() => {
    if (!loggedInCustomer?.id) return;

    const echo = getEcho(baseUrl);
    if (!echo) return;

    const channel = echo.private(`customer.${loggedInCustomer.id}`);

    channel.listen(".new-notification", (e) => {
      setNotifications((prev) => [e.notification, ...prev]);
    });

    return () => {
      echo.leave(`customer.${loggedInCustomer.id}`);
    };
  }, [loggedInCustomer, baseUrl]);

  // ✅ FIX 1: unread check — DB se status string "unread" aata hai
  const isUnread = (n) => n.status === 'unread' || n.isRead === false;

  const unreadCount = notifications.filter(isUnread).length;

  // ✅ FIX 2: filter bhi status se karo
  const filteredNotifications = notifications.filter(notif => {
    if (filter === 'unread') return isUnread(notif);
    if (filter === 'read')   return !isUnread(notif);
    return true;
  });

  // ── API ──
    // ── API ──
  const viewAllNotifications = () => {
    console.log("**********this is customer in the cart page", loggedInCustomer);
    const token = localStorage.getItem("authToken");
    const formData = new FormData();
    formData.append("srcustomer_id", loggedInCustomer.id); // ✅ lowercase
    setLoading(true);
    axios
      .post(
        `${baseUrl}/customer/notifications/viewAllNotifications`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        setLoading(false);
        if (response.data.hasOwnProperty("error")) {
          Swal.fire({ icon: "error", title: "Error", text: response.data.error });
        } else {
          setNotifications(response.data.notifications);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Swal.fire({ icon: "error", title: "Error", text: "Failed to load notifications." });
      });
  };

  useEffect(() => {
    viewAllNotifications();
  }, []);

  // ── Handlers — ab backend ko call karte hain, local-state-only nahi ──
  const markAsRead = (id) => {
    const token = localStorage.getItem("authToken");
    axios
      .post(
        `${baseUrl}/customer/notifications/markAsRead`,
        { id, srcustomer_id: loggedInCustomer.id },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) =>
            prev.map((n) => (n.id === id ? { ...n, status: 'read', isRead: true } : n))
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const markAllAsRead = () => {
    const token = localStorage.getItem("authToken");
    axios
      .post(
        `${baseUrl}/customer/notifications/markAllAsRead`,
        { srcustomer_id: loggedInCustomer.id },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) => prev.map((n) => ({ ...n, status: 'read', isRead: true })));
        }
      })
      .catch((err) => console.log(err));
  };

  const deleteNotification = (id) => {
    if (!window.confirm('Are you sure you want to delete this notification?')) return;
    const token = localStorage.getItem("authToken");
    axios
      .post(
        `${baseUrl}/customer/notifications/deleteNotification`,
        { id, srcustomer_id: loggedInCustomer.id },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) => prev.filter((n) => n.id !== id));
        }
      })
      .catch((err) => console.log(err));
  };

  const clearAllRead = () => {
    if (!window.confirm('Clear all read notifications?')) return;
    const token = localStorage.getItem("authToken");
    axios
      .post(
        `${baseUrl}/customer/notifications/clearRead`,
        { srcustomer_id: loggedInCustomer.id },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) => prev.filter((n) => isUnread(n)));
        }
      })
      .catch((err) => console.log(err));
  };

  // ✅ FIX 5: type se icon decide karo — DB se icon nahi aata
  const getTypeIcon = (type) => {
    const map = {
      booking:     FaShoppingCart,
      rental:      FaTractor,
      payment:     FaMoneyBillWave,
      maintenance: FaTools,
      dispute:     FaExclamationTriangle,
      review:      FaStar,
    };
    return map[type] || FaBell; // default icon
  };

  // ── Type badge ──
  const getTypeBadge = (type) => {
    const map = {
      booking:     { label: 'Booking',     bg: '#E6F9EE', color: '#28a745' },
      rental:      { label: 'Rental',      bg: '#FFF8E6', color: '#FDB714' },
      payment:     { label: 'Payment',     bg: '#E6F9EE', color: '#28a745' },
      maintenance: { label: 'Maintenance', bg: '#FFF3E6', color: '#fd7e14' },
      dispute:     { label: 'Dispute',     bg: '#FFE6E6', color: '#dc3545' },
      review:      { label: 'Review',      bg: '#FFF8E6', color: '#FDB714' },
    };
    return map[type] || { label: type, bg: '#f0f0f0', color: '#666' };
  };

  // ✅ FIX 6: time format — DB se created_at aata hai
  const formatTime = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleString('en-PK', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  // ================================================================
  // RETURN
  // ================================================================
  return (
    <UserMasterLayout>
      <div className="un-page">
        <Container fluid>

          {/* ── Header ── */}
          <div className="un-header">
            <div className="un-header-left">
              <h2 className="un-title">Notifications</h2>
              {unreadCount > 0 && (
                <Badge className="un-unread-badge">{unreadCount} New</Badge>
              )}
            </div>
            <div className="un-header-actions">
              <Button
                className="un-mark-all-btn"
                onClick={markAllAsRead}
                disabled={unreadCount === 0}
              >
                <FaEnvelopeOpen /> Mark All as Read
              </Button>
              <Button
                variant="outline"
                className="un-clear-all-btn"
                onClick={clearAllRead}
              >
                Clear Read
              </Button>
            </div>
          </div>

          {/* ── Filter Tabs ── */}
          <div className="user-filter-section">
            <ButtonGroup className="user-filter-buttons">
              <Button
                className={`user-filter-btn ${filter === 'all' ? 'active' : ''}`}
                onClick={() => setFilter('all')}
              >
                All ({notifications.length})
              </Button>
              <Button
                className={`user-filter-btn ${filter === 'unread' ? 'active' : ''}`}
                onClick={() => setFilter('unread')}
              >
                Unread ({unreadCount})
              </Button>
              <Button
                className={`user-filter-btn ${filter === 'read' ? 'active' : ''}`}
                onClick={() => setFilter('read')}
              >
                Read ({notifications.length - unreadCount})
              </Button>
            </ButtonGroup>
          </div>

          {/* ── Loading ── */}
          {loading && (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>Loading notifications...</p>
            </div>
          )}

          {/* ── Notifications List ── */}
          {!loading && (
            <Row>
              <Col>
                <div className="un-list">
                  {filteredNotifications.length > 0 ? (
                    filteredNotifications.map(notification => {
                      // ✅ FIX 5: icon DB se nahi aata — type se decide karo
                      const IconComponent = getTypeIcon(notification.type);
                      const typeBadge = getTypeBadge(notification.type);
                      const unread = isUnread(notification);

                      return (
                        <Card
                          key={notification.id}
                          className={`un-card ${unread ? 'un-unread' : ''}`}
                        >
                          <Card.Body>
                            <div className="un-card-content">

                              {/* Icon */}
                              <div
                                className="un-icon"
                                style={{
                                  backgroundColor: `${typeBadge.color}20`,
                                  color: typeBadge.color
                                }}
                              >
                                <IconComponent size={20} />
                              </div>

                              {/* Details */}
                              <div className="un-details">
                                <div className="un-title-row">
                                  <h5 className="un-card-title">{notification.title}</h5>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span style={{
                                      fontSize: '11px', fontWeight: 600,
                                      padding: '2px 8px', borderRadius: '20px',
                                      background: typeBadge.bg, color: typeBadge.color
                                    }}>
                                      {typeBadge.label}
                                    </span>
                                    {unread && (
                                      <Badge className="un-new-badge">New</Badge>
                                    )}
                                  </div>
                                </div>

                                {/* ✅ FIX 7: DB mein description hai, message nahi */}
                                <p className="un-message">
                                  {notification.description || notification.message}
                                </p>

                                {/* ✅ FIX 6: created_at format karo */}
                                <span className="un-time">
                                  <FaClock size={11} style={{ marginRight: 4 }} />
                                  {formatTime(notification.created_at || notification.time)}
                                </span>
                              </div>

                              {/* Actions */}
                              <div className="user-notification-actions">
                                {unread && (
                                  <button
                                    className="user-action-btn read-btn"
                                    onClick={() => markAsRead(notification.id)}
                                    title="Mark as read"
                                  >
                                    <FaEnvelopeOpen />
                                  </button>
                                )}
                                <button
                                  className="user-action-btn delete-btn"
                                  onClick={() => deleteNotification(notification.id)}
                                  title="Delete"
                                >
                                  <FaTrash />
                                </button>
                              </div>

                            </div>
                          </Card.Body>
                        </Card>
                      );
                    })
                  ) : (
                    <div className="un-empty">
                      <FaBell className="un-empty-icon" />
                      <h4>No Notifications</h4>
                      <p>You're all caught up!</p>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          )}

        </Container>
      </div>
    </UserMasterLayout>
  );
};

export default UserNotificationsPage;